import { computed, Injectable, signal } from '@angular/core'
import { toObservable } from '@angular/core/rxjs-interop'
import { formatDate } from '@angular/common'

import { environment } from '@env'

import { FullDate } from './full-date-filter'

@Injectable({
	providedIn: 'root',
})
export class FullDateFilterState {
	get #startDate() {
		if (environment.production) {
			return formatDate(new Date(), 'yyyy-MM-ddT00:00:00.000000', 'en-US')
		}

		return formatDate(new Date(), '2018-MM-ddT00:00:00.000000', 'en-US')
	}

	readonly #initFullDate: FullDate = {
		startDate: formatDate(new Date(), this.#startDate, 'en-US'),
		endDate: formatDate(new Date(), 'yyyy-MM-ddT23:59:59.999999', 'en-US'),
		searchByParked: true,
		searchByCheckout: true,
		searchByTempCheckout: true,
	}

	readonly signalFullDate = signal<FullDate>(this.#initFullDate)
	readonly fullDate$ = toObservable(this.signalFullDate)
	readonly isDateRange = signal<boolean>(false)
	readonly isDateRange$ = toObservable(this.isDateRange)
	readonly isTicketTransactionsPage = signal<boolean>(false)
	readonly isTicketTransactionsOvernight = signal<boolean>(false)
	readonly label = computed(() => {
		const { startDate, endDate } = this.signalFullDate()
		const currentYear = new Date().getFullYear()
		const startDateYear = new Date(startDate).getFullYear()
		const endDateYear = new Date(endDate).getFullYear()

		if (startDateYear === endDateYear && startDateYear === currentYear) {
			const start = formatDate(startDate, 'MMM d', 'en-US')
			const end = formatDate(endDate, 'MMM d', 'en-US')

			return `${start} - ${end}`
		}

		const start = formatDate(startDate, 'MMM d, yyyy', 'en-US')
		const end = formatDate(endDate, 'MMM d, yyyy', 'en-US')

		return `${start} - ${end}`
	})
}
